/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Feature,
  FeatureActorInput,
  FeatureChangesList,
  FeatureGroupInput,
  FeaturePercentageInput,
  FeaturesList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Features list
 */
export const adminFeatures = (

 signal?: AbortSignal
) => {


      return axiosClient<FeaturesList>(
      {url: `/features`, method: 'GET', signal
    },
      );
    }




export const getAdminFeaturesQueryKey = () => {
    return [
    'features'
    ] as const;
    }


export const getAdminFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof adminFeatures>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeatures>>> = ({ signal }) => adminFeatures(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>
}

export type AdminFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeatures>>>
export type AdminFeaturesQueryError = ErrorType<StandardError>


/**
 * @summary Features list
 */

export function useAdminFeatures<TData = Awaited<ReturnType<typeof adminFeatures>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Feature Detail
 */
export const adminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}`, method: 'GET', signal
    },
      );
    }




export const getAdminFeatureQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'features',id
    ] as const;
    }


export const getAdminFeatureQueryOptions = <TData = Awaited<ReturnType<typeof adminFeature>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminFeatureQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeature>>> = ({ signal }) => adminFeature(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>
}

export type AdminFeatureQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeature>>>
export type AdminFeatureQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Feature Detail
 */

export function useAdminFeature<TData = Awaited<ReturnType<typeof adminFeature>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeature>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeatureQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Disable Feature
 */
export const disableAdminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableAdminFeatureMutationKey = () => ['disableAdminFeature'] as const;

export const getDisableAdminFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,DisableAdminFeatureMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,DisableAdminFeatureMutationVariables, TContext> => {

const mutationKey = getDisableAdminFeatureMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeature>>, DisableAdminFeatureMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  disableAdminFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeature>>>

    export type DisableAdminFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DisableAdminFeatureMutationVariables = {id: string}

    /**
 * @summary Disable Feature
 */
export const useDisableAdminFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeature>>, TError,DisableAdminFeatureMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeature>>,
        TError,
        DisableAdminFeatureMutationVariables,
        TContext
      > => {
      return useMutation(getDisableAdminFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable Feature for Actor
 */
export const disableAdminFeatureActor = (
    id: MaybeRefOrGetter<string>,
    featureActorInput?: MaybeRefOrGetter<FeatureActorInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureActorInput = toValue(featureActorInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable-actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureActorInput, signal
    },
      );
    }




export const getDisableAdminFeatureActorMutationKey = () => ['disableAdminFeatureActor'] as const;

export const getDisableAdminFeatureActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,DisableAdminFeatureActorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,DisableAdminFeatureActorMutationVariables, TContext> => {

const mutationKey = getDisableAdminFeatureActorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeatureActor>>, DisableAdminFeatureActorMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  disableAdminFeatureActor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureActorMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeatureActor>>>
    export type DisableAdminFeatureActorMutationBody = FeatureActorInput | undefined
    export type DisableAdminFeatureActorMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DisableAdminFeatureActorMutationVariables = {id: string;data?: FeatureActorInput}

    /**
 * @summary Disable Feature for Actor
 */
export const useDisableAdminFeatureActor = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureActor>>, TError,DisableAdminFeatureActorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeatureActor>>,
        TError,
        DisableAdminFeatureActorMutationVariables,
        TContext
      > => {
      return useMutation(getDisableAdminFeatureActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable Feature for Group
 */
export const disableAdminFeatureGroup = (
    id: MaybeRefOrGetter<string>,
    featureGroupInput?: MaybeRefOrGetter<FeatureGroupInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureGroupInput = toValue(featureGroupInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/disable-group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureGroupInput, signal
    },
      );
    }




export const getDisableAdminFeatureGroupMutationKey = () => ['disableAdminFeatureGroup'] as const;

export const getDisableAdminFeatureGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,DisableAdminFeatureGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,DisableAdminFeatureGroupMutationVariables, TContext> => {

const mutationKey = getDisableAdminFeatureGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, DisableAdminFeatureGroupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  disableAdminFeatureGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAdminFeatureGroupMutationResult = NonNullable<Awaited<ReturnType<typeof disableAdminFeatureGroup>>>
    export type DisableAdminFeatureGroupMutationBody = FeatureGroupInput | undefined
    export type DisableAdminFeatureGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DisableAdminFeatureGroupMutationVariables = {id: string;data?: FeatureGroupInput}

    /**
 * @summary Disable Feature for Group
 */
export const useDisableAdminFeatureGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAdminFeatureGroup>>, TError,DisableAdminFeatureGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableAdminFeatureGroup>>,
        TError,
        DisableAdminFeatureGroupMutationVariables,
        TContext
      > => {
      return useMutation(getDisableAdminFeatureGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature
 */
export const enableAdminFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableAdminFeatureMutationKey = () => ['enableAdminFeature'] as const;

export const getEnableAdminFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,EnableAdminFeatureMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,EnableAdminFeatureMutationVariables, TContext> => {

const mutationKey = getEnableAdminFeatureMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeature>>, EnableAdminFeatureMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  enableAdminFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeature>>>

    export type EnableAdminFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type EnableAdminFeatureMutationVariables = {id: string}

    /**
 * @summary Enable Feature
 */
export const useEnableAdminFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeature>>, TError,EnableAdminFeatureMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeature>>,
        TError,
        EnableAdminFeatureMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAdminFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Actor
 */
export const enableAdminFeatureActor = (
    id: MaybeRefOrGetter<string>,
    featureActorInput?: MaybeRefOrGetter<FeatureActorInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureActorInput = toValue(featureActorInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureActorInput, signal
    },
      );
    }




export const getEnableAdminFeatureActorMutationKey = () => ['enableAdminFeatureActor'] as const;

export const getEnableAdminFeatureActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,EnableAdminFeatureActorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,EnableAdminFeatureActorMutationVariables, TContext> => {

const mutationKey = getEnableAdminFeatureActorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeatureActor>>, EnableAdminFeatureActorMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeatureActor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureActorMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeatureActor>>>
    export type EnableAdminFeatureActorMutationBody = FeatureActorInput | undefined
    export type EnableAdminFeatureActorMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type EnableAdminFeatureActorMutationVariables = {id: string;data?: FeatureActorInput}

    /**
 * @summary Enable Feature for Actor
 */
export const useEnableAdminFeatureActor = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureActor>>, TError,EnableAdminFeatureActorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeatureActor>>,
        TError,
        EnableAdminFeatureActorMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAdminFeatureActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Group
 */
export const enableAdminFeatureGroup = (
    id: MaybeRefOrGetter<string>,
    featureGroupInput?: MaybeRefOrGetter<FeatureGroupInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featureGroupInput = toValue(featureGroupInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureGroupInput, signal
    },
      );
    }




export const getEnableAdminFeatureGroupMutationKey = () => ['enableAdminFeatureGroup'] as const;

export const getEnableAdminFeatureGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,EnableAdminFeatureGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,EnableAdminFeatureGroupMutationVariables, TContext> => {

const mutationKey = getEnableAdminFeatureGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, EnableAdminFeatureGroupMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeatureGroup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeatureGroupMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeatureGroup>>>
    export type EnableAdminFeatureGroupMutationBody = FeatureGroupInput | undefined
    export type EnableAdminFeatureGroupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type EnableAdminFeatureGroupMutationVariables = {id: string;data?: FeatureGroupInput}

    /**
 * @summary Enable Feature for Group
 */
export const useEnableAdminFeatureGroup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeatureGroup>>, TError,EnableAdminFeatureGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeatureGroup>>,
        TError,
        EnableAdminFeatureGroupMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAdminFeatureGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Percentage of Actors
 */
export const enableAdminFeaturePercentageOfActors = (
    id: MaybeRefOrGetter<string>,
    featurePercentageInput?: MaybeRefOrGetter<FeaturePercentageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featurePercentageInput = toValue(featurePercentageInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-percentage-of-actors`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featurePercentageInput, signal
    },
      );
    }




export const getEnableAdminFeaturePercentageOfActorsMutationKey = () => ['enableAdminFeaturePercentageOfActors'] as const;

export const getEnableAdminFeaturePercentageOfActorsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,EnableAdminFeaturePercentageOfActorsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,EnableAdminFeaturePercentageOfActorsMutationVariables, TContext> => {

const mutationKey = getEnableAdminFeaturePercentageOfActorsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, EnableAdminFeaturePercentageOfActorsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeaturePercentageOfActors(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeaturePercentageOfActorsMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>>
    export type EnableAdminFeaturePercentageOfActorsMutationBody = FeaturePercentageInput | undefined
    export type EnableAdminFeaturePercentageOfActorsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type EnableAdminFeaturePercentageOfActorsMutationVariables = {id: string;data?: FeaturePercentageInput}

    /**
 * @summary Enable Feature for Percentage of Actors
 */
export const useEnableAdminFeaturePercentageOfActors = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>, TError,EnableAdminFeaturePercentageOfActorsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeaturePercentageOfActors>>,
        TError,
        EnableAdminFeaturePercentageOfActorsMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAdminFeaturePercentageOfActorsMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Feature for Percentage of Time
 */
export const enableAdminFeaturePercentageOfTime = (
    id: MaybeRefOrGetter<string>,
    featurePercentageInput?: MaybeRefOrGetter<FeaturePercentageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
featurePercentageInput = toValue(featurePercentageInput);

      return axiosClient<Feature>(
      {url: `/features/${id}/enable-percentage-of-time`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featurePercentageInput, signal
    },
      );
    }




export const getEnableAdminFeaturePercentageOfTimeMutationKey = () => ['enableAdminFeaturePercentageOfTime'] as const;

export const getEnableAdminFeaturePercentageOfTimeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,EnableAdminFeaturePercentageOfTimeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,EnableAdminFeaturePercentageOfTimeMutationVariables, TContext> => {

const mutationKey = getEnableAdminFeaturePercentageOfTimeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, EnableAdminFeaturePercentageOfTimeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  enableAdminFeaturePercentageOfTime(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAdminFeaturePercentageOfTimeMutationResult = NonNullable<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>>
    export type EnableAdminFeaturePercentageOfTimeMutationBody = FeaturePercentageInput | undefined
    export type EnableAdminFeaturePercentageOfTimeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type EnableAdminFeaturePercentageOfTimeMutationVariables = {id: string;data?: FeaturePercentageInput}

    /**
 * @summary Enable Feature for Percentage of Time
 */
export const useEnableAdminFeaturePercentageOfTime = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>, TError,EnableAdminFeaturePercentageOfTimeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableAdminFeaturePercentageOfTime>>,
        TError,
        EnableAdminFeaturePercentageOfTimeMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAdminFeaturePercentageOfTimeMutationOptions(options), queryClient);
    }
    /**
 * @summary Feature Change History
 */
export const adminFeatureHistory = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FeatureChangesList>(
      {url: `/features/${id}/history`, method: 'GET', signal
    },
      );
    }




export const getAdminFeatureHistoryQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'features',id,'history'
    ] as const;
    }


export const getAdminFeatureHistoryQueryOptions = <TData = Awaited<ReturnType<typeof adminFeatureHistory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminFeatureHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeatureHistory>>> = ({ signal }) => adminFeatureHistory(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeatureHistory>>, TError, TData>
}

export type AdminFeatureHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeatureHistory>>>
export type AdminFeatureHistoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Feature Change History
 */

export function useAdminFeatureHistory<TData = Awaited<ReturnType<typeof adminFeatureHistory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeatureHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Toggle Feature Fleet Self-Service
 */
export const toggleAdminFeatureFleetSelfService = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/toggle-fleet-self-service`, method: 'PUT', signal
    },
      );
    }




export const getToggleAdminFeatureFleetSelfServiceMutationKey = () => ['toggleAdminFeatureFleetSelfService'] as const;

export const getToggleAdminFeatureFleetSelfServiceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>, TError,ToggleAdminFeatureFleetSelfServiceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>, TError,ToggleAdminFeatureFleetSelfServiceMutationVariables, TContext> => {

const mutationKey = getToggleAdminFeatureFleetSelfServiceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>, ToggleAdminFeatureFleetSelfServiceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  toggleAdminFeatureFleetSelfService(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleAdminFeatureFleetSelfServiceMutationResult = NonNullable<Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>>

    export type ToggleAdminFeatureFleetSelfServiceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ToggleAdminFeatureFleetSelfServiceMutationVariables = {id: string}

    /**
 * @summary Toggle Feature Fleet Self-Service
 */
export const useToggleAdminFeatureFleetSelfService = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>, TError,ToggleAdminFeatureFleetSelfServiceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleAdminFeatureFleetSelfService>>,
        TError,
        ToggleAdminFeatureFleetSelfServiceMutationVariables,
        TContext
      > => {
      return useMutation(getToggleAdminFeatureFleetSelfServiceMutationOptions(options), queryClient);
    }
    /**
 * @summary Toggle Feature User Self-Service
 */
export const toggleAdminFeatureUserSelfService = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Feature>(
      {url: `/features/${id}/toggle-user-self-service`, method: 'PUT', signal
    },
      );
    }




export const getToggleAdminFeatureUserSelfServiceMutationKey = () => ['toggleAdminFeatureUserSelfService'] as const;

export const getToggleAdminFeatureUserSelfServiceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>, TError,ToggleAdminFeatureUserSelfServiceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>, TError,ToggleAdminFeatureUserSelfServiceMutationVariables, TContext> => {

const mutationKey = getToggleAdminFeatureUserSelfServiceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>, ToggleAdminFeatureUserSelfServiceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  toggleAdminFeatureUserSelfService(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleAdminFeatureUserSelfServiceMutationResult = NonNullable<Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>>

    export type ToggleAdminFeatureUserSelfServiceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ToggleAdminFeatureUserSelfServiceMutationVariables = {id: string}

    /**
 * @summary Toggle Feature User Self-Service
 */
export const useToggleAdminFeatureUserSelfService = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>, TError,ToggleAdminFeatureUserSelfServiceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleAdminFeatureUserSelfService>>,
        TError,
        ToggleAdminFeatureUserSelfServiceMutationVariables,
        TContext
      > => {
      return useMutation(getToggleAdminFeatureUserSelfServiceMutationOptions(options), queryClient);
    }
